var host = "http://192.168.1.102:5100";
var token_api = "0d7366a14e0f0fd2df0161c691779983";
var token_user = "";
const tokenmaps = "AIzaSyAf3_MZQpe7I2aDgasoWD6VnIDR8GVha8Q";
export var version = "/v2/"
var token_empresa = "";
let proddev = process.env.NODE_ENV;


let preBoby = {};


function motarHead(headers) {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    "x-request-id": token_api,
    "token-user": token_user,
    "token-empresa": token_empresa
  };
}

export default {
  getHost() {
    return host;
  },
  gettokenmaps() {
    return tokenmaps
  },
  getVersion() {
    return version;
  },

  getToken() {
    return token_api;
  },
  setTokenUser(token) {
    token_user = token;
  },
  setTokenProjeto(token) {
    // token_projeto = token;
  },
  setTokenEmpresa(token) {
    token_empresa = token;
  },
  getTokenEmpresa() {
    return token_empresa;
  },
  getTokenUser() {
    return token_user;
  },
  post(metodo, data, retorno) {
    var url = host + version + metodo;
    // console.log(url);
    var config = {
      method: "POST",
      headers: motarHead(),
      body: JSON.stringify({ ...data, ...preBoby })
    };

    this.onFetch(url, config, retorno);
  },
  get(metodo, data, retorno) {
    data = { ...data, ...preBoby };
    var config = {
      method: "GET",
      headers: motarHead()
    };

    if (data.forcarsemcache) {
      config.cache = 'no-cache';
      data.forcarsemcache = null;
    }
    var url = host + version + metodo;
    if (data) {
      url += "?";
      var lista = Object.keys(data);
      for (var i = 0; i < lista.length; i++) {
        var item = lista[i];
        if (
          data[item] + "" === "undefined" ||
          data[item] + "" === "null"
        )
          continue;
        if (i !== 0) {
          url += "&";
        }
        // url += "" + item + "=" + encodeURI(data[item]);
        url +=
          "" +
          item +
          "=" +
          (this.isObject(data[item]) || this.isArray(data[item])
            ? JSON.stringify(data[item])
            : encodeURI(data[item]));
      }
    }

    this.onFetch(url, config, retorno);
  },
  put(metodo, data, retorno) {
    var url = host + version + metodo;
    // console.log(url);
    var config = {
      method: "PUT",
      headers: motarHead(),
      body: JSON.stringify({ ...data, ...preBoby })
    };

    this.onFetch(url, config, retorno);
  },
  delete(metodo, data, retorno) {
    var url = host + version + metodo;
    // console.log(url);
    var config = {
      method: "DELETE",
      headers: motarHead(),
      body: JSON.stringify({ ...data, ...preBoby })
    };

    this.onFetch(url, config, retorno);
  },
  onFetch(url = "", config = {}, retorno = console.log) {
    fetch(url, config)
      .then(response => {
        this.onResolverResponse(response, (sucess, error) => {
          if (error) console.log(error);
          retorno(sucess, error);
        });
      })
      .catch(error => {
        if (retorno) retorno(undefined, error);
      });
  },
  onResolverResponse(response, retorno) {
    if (!response || !response.json)
      return retorno(undefined, { msg: "not JSON" });
    var p1 = response.json();
    p1.then((responseData, error) => {
      if (response.status !== 200) {
        retorno(undefined, responseData);
      } else if (error) {
        retorno(undefined, error);
      } else {
        retorno(responseData);
      }
    });
  },
  isObject(val) {
    return typeof val === "object";
  },
  isArray(object) {
    if (object && JSON.stringify(object) === "[]") {
      return true;
    }
    if (object && object.constructor && object.constructor === Array) {
      return true;
    } else {
      return false;
    }
  }
};
